import PropTypes from 'prop-types'

import { InboxMessage } from '../../models/inbox-message/inbox-message-enum'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { inboxMessageAttributePropType } from './inbox-message-attribute-prop-type'

const { ATTRIBUTES, END_DATE, ID, IS_READ, MAINTENANCE_DATE, START_DATE, TITLE } = InboxMessage

/**
 * @typedef {Object} InboxMessage
 *
 * @property {Id} id                    - The inbox message id unique identifier
 * @property {ISO8601} maintenanceDate  - The inbox message maintenance date
 * @property {ISO8601} [startDate]      - The inbox message start date
 * @property {ISO8601} [endDate]        - The inbox message end date
 * @property {boolean} [isRead]         - Whether the inbox message was read by a user
 * @property {string} title             - The inbox message title
 * @property {Array.<InboxMessageAttribute>} [attributes] - The inbox message attributes list
 */
const inboxMessagePropType = PropTypes.shape({
    [ID]: idPropType.isRequired,
    [MAINTENANCE_DATE]: iso8601PropType.isRequired,
    [START_DATE]: iso8601PropType,
    [END_DATE]: iso8601PropType,
    [IS_READ]: PropTypes.bool,
    [TITLE]: PropTypes.string.isRequired,
    [ATTRIBUTES]: PropTypes.arrayOf(inboxMessageAttributePropType)
})

export { inboxMessagePropType }
